import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

class InputLabel extends React.PureComponent {
    render() {
        const {
            inline, children, checkbox, centered,
        } = this.props;
        const inlineStyle = inline ? styles.inline : '';
        const centeredStyle = centered ? styles.centered : '';
        const checkboxStyle = checkbox ? styles.checkbox : '';

        return (
            <span className={`${styles['input-label']} ${centeredStyle} ${inlineStyle} ${checkboxStyle}`}>
                {children}
            </span>
        );
    }
}

InputLabel.propTypes = {
    inline: PropTypes.bool,
    children: PropTypes.node.isRequired,
    checkbox: PropTypes.bool,
    centered: PropTypes.bool,
};

InputLabel.defaultProps = {
    inline: false,
    checkbox: false,
    centered: false,
};

export default InputLabel;
